
export default {
  props: {
    text: {type: String, required: true},
    mode: {type: String, required: true}
  },
  computed: {
    c_icon () {
      return this.mode === 'compact' ? 'white' : 'var(--gray-800)'
    }
  }
}
